module.exports = __webpack_public_path__ + "img/add-complete.8987ed7c.png";